
import Radio from './Radio';
import RadioGroup from './RadioGroup';

Radio.Group = RadioGroup;

export default Radio;



// WEBPACK FOOTER //
// ./components/Radio/index.js